import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  odometerText: {
    fontWeight: theme.typography.fontWeightMedium,
    marginLeft: theme.spacing(1),
  },
  red: {
    color: theme.palette.error.main,
  },
  update: {
    textTransform: 'capitalize',
  },
  notificationContainer: {
  },
  loadingContainer: {
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
  },
  notificationContent: {
    alignItems: 'center',
    borderRadius: '8px',
    boxShadow: theme.shadows[4],
    background: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: '60%',
    padding: '2em 1em 1em',
    position: 'relative',
    width: '100%',
  },
  notificationIcon: {
    width: '2.4em',
  },
  boxContainer: {
    marginBottom: 5,
    padding: 20,
  },
  list: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'flex-start',
    padding: 0,
  },

  listItem: {
    width: '100%',
    padding: '10px 4px 8px 0',
    '&:not(:last-of-type)': {
      borderBottom: `1px solid ${theme.palette.common.greyLight}`,
    },
    '&:last-child': {
      paddingBottom: 0,
    },
  },
  notificationTitle: {
    color: theme.palette.primary.lightGray,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: '700',
  },
  notificationSubtitle: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.fontSize,
    margin: '10px 0',
    textAlign: 'center',
  },
  subtitles: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.text.subtitle,
    fontWeight: theme.typography.fontWeightMedium,
  },
  timezone: {
    color: theme.palette.text.secondary,
  },
  gpsTitle: {
    color: theme.palette.text.subtitle,
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 'bold',
    lineHeight: 1,
  },
  gpsIcon: {
    color: theme.palette.text.secondary,
    marginRight: 10,
  },
}));

const listTextStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      '&  .MuiGrid-item:first-child': {
        flexGrow: 1,
        maxWidth: '75%',
      },
      '&  .MuiGrid-item:last-child': {
        maxWidth: '25%',
      },
    },
    primary: {
      fontSize: theme.typography.pxToRem(13),
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.text.subtitle,
      wordBreak: 'break-word',
    },

    secondary: {
      width: '100%',
    },
  };
});

const customCardStyles = makeStyles((theme) => {
  return {
    root: {
      paddingLeft: 14,
      paddingRight: 30,
    },
  };
});

export { useStyles, listTextStyles, customCardStyles };
